<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'order',
      getListUrl: 'escortrec',
      breadcrumb: [
        { name: "财务管理", path: "/finance/estimatedProfit" },
        { name: "车队利润表", path: "/finance/estimatedProfit" },
        { name: "当月运单" },
      ],
      cols: [
        { keyName: "order_num", label: "运单编号", minwidth: 150 },
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "driver", label: "司机姓名", minwidth: 120 },
        { keyName: "shname", label: "客户名称", minwidth: 120 },
        { keyName: "name", label: "货物名称", minwidth: 120 },
        { keyName: "pricing_name", label: "计价方式", minwidth: 120 },
        { keyName: "coaddress", label: "装货地址", minwidth: 120 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 120 },
        { keyName: "predict_loading_date", label: "装货日期", minwidth: 120 },
        { keyName: "predict_unloading_date", label: "卸货日期", minwidth: 120 },
        { keyName: "inton", label: "装货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "unton", label: "卸货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "untons", label: "亏吨重量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "ceton", label: "客担亏吨", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dtonprice", label: "亏吨单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dtonprices", label: "亏吨金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "cprice", label: "公司单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "freight", label: "公司运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dprice", label: "司机单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dfreight", label: "司机运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "total", label: "出车费用", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "additional", label: "附加费用", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "compen", label: "补差金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "profit", label: "运单毛利额", align: 'right', className: 'pr30', minwidth: 120 },
        // { keyName: "message", label: "信息费", align: 'right', className: 'pr30', width: 100 },
        // { keyName: "freight", label: "运费", align: 'right', className: 'pr30', width: 100 },
        // { keyName: "total", label: "出车费用", align: 'right', className: 'pr30', width: 100 },
        // { keyName: "compen", label: "运单补差", align: 'right', className: 'pr30', width: 100 },
        // { keyName: "profit", label: "利润", align: 'right', className: 'pr30', width: 100 },
      ],
      baseParams: ['month', 'license'],
      getTotalProperty: [
        'inton',
        'unton',
        'untons',
        'dtonprices',
        'freight',
        'dfreight',
        'total',
        'additional',
        'compen',
        'profit',
      ],
    };
  },
  methods: {},
  mounted() {
    this.setQueryParams();
    this.$nextTick(this.getList);
  },
};
</script>
